export class CoAdminModel {
  emailId: string;
  alternateEmailId: string;
  mobileNumber: string;
  name: string;
  department: string;
  id: number;
  profileUrl: string;
  deptId: number
}
